
import acceptenceTime from "~/assets/images/insights/acceptence-time.svg";
import revenuePerHour from "~/assets/images/insights/revenue-per-hour.svg";
import AdvancePaymentTransferConfirmation from "./advance-payment-transfer-confirmation.vue";

export default {
  components: { AdvancePaymentTransferConfirmation },
  data() {
    return {
      acceptenceTime,
      revenuePerHour,
      showTransferConfirmationDialog: false,
      payoutAmount: [
        {
          id: 1,
          label: "Total Sale",
          amount: "₹39600.00"
        },
        {
          id: 2,
          label: "Commission",
          amount: "₹9000.00"
        },

        {
          id: 3,
          label: "Mer. Discount",
          amount: "₹10000.00"
        },
        {
          id: 4,
          label: "Cancellation Fee",
          amount: "₹600.00"
        },
        {
          id: 5,
          label: "Taxes",
          amount: "₹375.65"
        },
        {
          id: 6,
          label: "Deductions last week",
          amount: "₹00.00"
        },
        {
          id: 1,
          label: "Additions last week",
          amount: "₹00.00"
        }
      ]
    };
  },
  methods: {
    toggleTransferConfirmationDialog(value) {
      this.showTransferConfirmationDialog = value;
    }
  }
};
